<template>
  <div>
    <el-row>
      <el-col>
        <div class="banner">
          
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="padding: 80px 0;">
        <div style="width: 1184px; margin: 0 auto;">
          <el-carousel :interval="3000" trigger="click" type="card" height="360px">
            <!--  style="width: 763px; height: 328px; padding: 5px; background: #fafafa;box-shadow: 0px 0px 20px 0px rgba(156, 156, 156, 0.5);transform: scale(.9);" -->
            <el-carousel-item v-for="item in teamIntroductionList" :key="item.id" style="box-shadow: 0px 0px 20px 0px rgba(156, 156, 156, 0.5);">
              <div>
                <!--  style="width: 98%; height: 320px; margin-top: 3px;" -->
                <img :src="item.img" alt="" style="width: 96%;height: 320px;background: rgb(250, 250, 250);padding: 15px;">
              </div>
            </el-carousel-item>
          </el-carousel>
          <p style="width: 470px;margin: 0 auto; color: #6B6B81; font-size: 14px; padding-top: 25px;">毅腾致力于培养优秀人才，积极开展各种培训、团建活动激发员工潜能，希望员工全面发展，提供健身、娱乐设施丰富员工日常生活</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      teamIntroductionList: [
        {
          id: 1,
          img: '//static.yiteng288.com/ecomm/pages/winsway/public/160514552392275248144_729_328.png'
        },
        {
          id: 2,
          img: '//static.yiteng288.com/ecomm/pages/winsway/public/160514552466683475584_729_328.png'
        },
        {
          id: 3,
          img: '//static.yiteng288.com/ecomm/pages/winsway/public/160514552526537469675_729_328.png'
        },
        {
          id: 4,
          img: '//static.yiteng288.com/ecomm/pages/winsway/public/160514552573420943056_729_328.png'
        },
        {
          id: 5,
          img: '//static.yiteng288.com/ecomm/pages/winsway/public/160514552592501734990_729_328.png'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../style/common.css';
/deep/.el-carousel__indicators--outside {
  display: none !important;
}
/deep/.el-carousel__mask {
  opacity: 0.6;
}
/deep/.el-carousel {
  padding-left: 14px;
  padding-right: 42px
}
/deep/.el-carousel__item {
  height: 97%;
}
/deep/.is-active {
  height: 96%;
  width: 64%;
  left: -75px;
}
.el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.banner {
  background: url('//static.yiteng288.com/ecomm/pages/winsway/public/160274066848269469148_1920_420.png') no-repeat;
  width: 100%;
  height: 420px;
  margin: 0 auto;
}
</style>